import { render, staticRenderFns } from "./sportLogInfo.vue?vue&type=template&id=6d8ccd3c&scoped=true&lang=pug&"
import script from "./sportLogInfo.vue?vue&type=script&lang=js&"
export * from "./sportLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ccd3c",
  null
  
)

export default component.exports